import { HighlightArea } from '@react-pdf-viewer/highlight';

export interface IRecordHeader {
    status: string;
    recordNumber: string;
    recordDate: string;
    dueDate: string;
    poNumber: string;
    problemCode?: string;
    statusId: {
        id: string;
        name: string;
    };
    problemCodeId: {
        id: string;
        name: string;
    };
    createdBy: {
        id: string;
        name: string;
    };
    receivedBy: {
        id: string;
        name: string;
    };
    approvedBy: {
        id: string;
        name: string;
    };
    assignedTo: {
        id: string;
        name: string;
    };
    recordType: {
        id: string;
        name: string;
    };
    additionalFields: {
        id: string;
        tag: string;
        value: any;
    }[];
}

export interface IGetRecordFileById {
    getMyRecordFileById: IRecordFile;
}

export interface IRecordFile {
    id: string;
    fileBucketId: string;
    hashPublic: string;
    createdAt: string;
    fileEncoded: string;
    annotation: string;
}

export interface IProblemCode {
    id: string;
    name: string;
    enabled: boolean;
    recordType: IRecordType;
}

export interface IFindRecordStatusByRecordType {
    findRecordStatusByRecordType: IRecordStatus[];
}

export interface IRecordStatus {
    enabled: boolean;
    id: string;
    name: string;
    recordType: {
        id: string;
    };
    recordHeaders: IRecordStatusHeader[] | null;
}

export interface IRecordType {
    id: string;
    name: string;
}

interface IRecordStatusHeader {
    status: string;
    statusId: any;
}

export interface IHighLightPart {
    highlightAreas: HighlightArea[];
    quote: string;
}

export interface IGetDocumentProperties {
    findRecordHeader: IRecordHeader[];
}

export const LAYOUT_POSITION = {
    ONLY_RECORD: 'ONLY_RECORD',
    ONLY_ADDITIONAL_INFO: 'ONLY_ADDITIONAL_INFO',
    SPLIT_VIEW: 'SPLIT_VIEW'
} as const;

export type LayoutPositionEnum = keyof typeof LAYOUT_POSITION;

export const ADDITIONAL_INFO_OPTIONS = {
    LINE_ITEMS: 'LINE_ITEMS',
    COMMENTS: 'COMMENTS',
    ATTACHMENTS: 'ATTACHMENTS'
} as const;

export type AdditionalInfoOptionsEnum = keyof typeof ADDITIONAL_INFO_OPTIONS;
